export default __webpack_public_path__ + "static/media/loko.ed9d4ee4.png";